import fetch from "isomorphic-fetch";
import API_SERVER from "../network";

const { NODE_ENV } = process.env;
export default function search(endpoint, query, version = "v1") {
  const restURL = NODE_ENV === "development" ? API_SERVER : "";
  const url = `${restURL}/api/${version}/search/${endpoint}/?q=${query}`;

  return fetch(url, {
    method: "GET",
    headers: {
      authorization: `Bearer ${localStorage.getItem("PPJWT")}`,
      "content-type": "application/json"
    },
    credentials: "same-origin"
  }).then(response => response.json());
}



// WEBPACK FOOTER //
// /src/rest/index.js